import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

// Usage:
//   <details class="animated-details group" data-controller="animated-details">
//     <summary data-action="click->animated-details#close">
//       ...
//       <a data-action="click->animated-details#stop">nested link</a>
//     </summary>
//     <div class="animated-details-body" data-animated-details-target="body">...</div>
//   </details>

// Must match the @supports condition in base.css, so exactly one of the
// CSS-native and JS-driven transitions runs.
const NATIVE_DETAILS_TRANSITIONS_SUPPORTED = window.CSS.supports('interpolate-size', 'allow-keywords')

class AnimatedDetailsController extends Controller {
  static targets = ['body']

  close (e) {
    if (NATIVE_DETAILS_TRANSITIONS_SUPPORTED) return
    if (!this.element.open || this.element.classList.contains('animated-details-closing')) return

    e.preventDefault()
    this.element.classList.add('animated-details-closing')

    const duration = parseFloat(window.getComputedStyle(this.bodyTarget).transitionDuration) * 1000
    // setTimeout, not transitionend: browsers pause CSS transitions in
    // backgrounded tabs, so transitionend can go unfired and leave the
    // card stuck half-open.
    setTimeout(() => {
      this.element.classList.remove('animated-details-closing')
      this.element.open = false
    }, duration)
  }

  stop (e) {
    e.stopPropagation()
  }
}

stimulus.register('animated-details', AnimatedDetailsController)
